/**
 * The running total on the punch screen, and why it never consults the phone's date.
 *
 * The screen shows the server's worked minutes plus the time that has passed since they were
 * loaded. That elapsed time used to be Date.now() minus the server's time, which a worker can
 * change: one set their phone a day ahead and watched "1h 23m" become "9h 07m — complete" while
 * the server, correctly, still said 1h 23m. The caller now passes the elapsed time from the
 * monotonic clock (performance.now()), which counts uptime and takes no notice of the date.
 * Nothing here reads a clock at all; that is the point, and what the test proves.
 */
export type RunningStatus = {
  open_shift: unknown;
  worked_minutes_running: number;
};

export function runningMinutes(status: RunningStatus, sinceLoadMs: number): number {
  if (!status.open_shift) return status.worked_minutes_running;
  return status.worked_minutes_running + Math.max(0, Math.floor(sinceLoadMs / 60_000));
}
